module.exports = __webpack_public_path__ + "90c5ef4b.svg";